import React, { useEffect } from 'react';

function ArticlePage04() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="xContent p-box py-6">
      <div className='xContent-wrapper'>
      <h1 class="title is-font-title-regular has-text-centered has-text-var-blue">С 7 по 12 июня состоится III Международный фестиваль классической музыки «Кантата»</h1>
      <div className="content">
      <p>В 2023 году программа фестиваля посвящена 150-летию со дня рождения великого русского композитора Сергея Рахманинова. Мероприятие будет проходить на исторических и общественных площадках Калининградской области и Калининграда.</p>
      <p>В рамках «Кантаты» состоится семь концертов, на которых прозвучат сочинения Рахманинова, в том числе дипломная работа композитора, опера «Алеко», и номера из «Всенощного бдения». Также в программе запланирован традиционный концерт с исполнением «Детского альбома» П.И. Чайковского и симфонической сказки «Петя и волк» С.С. Прокофьева.</p>
      <p>Также гостей ждет ночной концерт органной музыки, специальная программа «Шедевры духовной музыки» и музыкально-драматический спектакль «Человек Земли» по мотивам творчества В. Шукшина. Гала-концерт у стен Кафедрального собора будет посвящен С.В. Рахманинову и Ф.И. Шаляпину, юбилей которого празднуется в этом году.</p>
      <p>Проект реализуется при поддержке Президентского фонда культурных инициатив. Организаторами фестиваля выступают Правительство Калининградской области, Министерство по культуре и туризму Калининградской области, АНО «Фестивальная дирекция».</p>
      <p>Партнеры фестиваля: Госкорпорация «Росатом», АНО «Кантата», Газпромбанк, ГАУ КО «Кафедральный собор», сервис «VK Музыка», МАУ «Молодежный центр».</p>



      </div>
      </div>
    </div>
  );
}

export default ArticlePage04;
